exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "wage-advance-form{display:block}wage-advance-form form{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}wage-advance-form form input{width:230px;margin-right:30px}wage-advance-form form select-app{width:452px;margin-right:30px}wage-advance-form form.mobile{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}wage-advance-form form.mobile input{width:100%;margin:20px 0 30px}wage-advance-form form.mobile label{font-size:16px}wage-advance-form form.mobile select-app{width:100%;margin-right:0;margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/wageAdvance/wageAdvanceForm/wageAdvanceForm.scss
// module id = 2123
// module chunks = 0